import React from "react";
import { Zoom } from "react-reveal";
import Slider from "react-slick";
// import Team1 from "../../assets/team-1.jpg";
// import Team2 from "../../assets/team-2.jpg";
// import Team3 from "../../assets/team-3.jpg";
// import Team4 from "../../assets/team-4.jpg";

const SampleNextArrow = (props) => {
  const { className, style, onClick } = props;
  return <div className={className} onClick={onClick} />;
};

const SamplePrevArrow = (props) => {
  const { className, style, onClick } = props;
  return <div className={className} onClick={onClick} />;
};

const teamDetails = [
  {
    name: "Mr. Nagesh Mestri",
    position: "Founder & Producer",
    instLink: "https://instagram.com/nageshmestri?igshid=YmMyMTA2M2Y=",
    imgLink: "images/team1.jpg",
  },
  {
    name: "Mr. Naimish Patel",
    position: "Chief Sound Engineer",
    instLink: "https://instagram.com/i_m_naimish_ptl?igshid=YmMyMTA2M2Y=",
    imgLink: "images/team2.jpg",
  },
  {
    name: "Ms. Ankita Surve",
    position: "Line Producer",
    instLink: "https://instagram.com/its_ankitasurve96k?igshid=YmMyMTA2M2Y=",
    imgLink: "images/team3.jpg",
  },
  {
    name: "Mr. Abid Khan",
    position: "Studio Manager",
    instLink: "https://instagram.com/abid8533khan?igshid=YmMyMTA2M2Y=",
    imgLink: "images/team4.jpg",
  },
  {
    name: "Zahen Khan",
    position: "Social Business Devloper",
    instLink: "https://instagram.com/zahenuu?igshid=YmMyMTA2M2Y=",
    imgLink: "images/team5.jpg",
  },
];

const Team = () => {
  var settings = {
    className: "row justify-content-between",
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
          infinite: true,
          speed: 1000,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          speed: 1000,
          dots: false,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          speed: 1000,
          dots: false,
          arrows: false,
        },
      },
    ],
  };

  return (
    <div id="Team" className="container-xxl py-4 team">
      <div className="container">
        <div className="text-center">
          <h6 className="section-title bg-white text-center text-primary px-3">
            <Zoom left>Team</Zoom>
          </h6>
          <Zoom right>
            <h1 className="mb-5 subtitle">Our Hard Working Team</h1>
          </Zoom>
        </div>

        <div className="align-items-center">
          <Zoom>
            <Slider {...settings}>
              {teamDetails.map((item, index) => (
                <div className="col-xl-3 col-lg-4 col-md-6 px-1">
                  <div className="member">
                    <img src={item.imgLink} className="img-fluid" alt="" />
                    <div className="member-info">
                      <div className="member-info-content">
                        <h4>{item.name}</h4>
                        <span>{item.position}</span>
                      </div>
                      <div className="social">
                        <a href={item.instLink} target="_blank">
                          <i className="bi bi-instagram"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </Zoom>
        </div>
      </div>
    </div>
  );
};

export default Team;
